import { Component, Element, Prop, Host, h } from '@stencil/core';

/**
 * The `pn-table` component is just a wrapper for your HTML table element.
 * You need to create the markup, but the component will deal with the styling.
 *
 * We have a built in class for divs inside table colums called `column-wrapper`.
 * This will line up your content and provide a grid gap.
 **/
@Component({
  tag: 'pn-table',
  styleUrl: 'pn-table.scss',
})
export class PnTable {
  @Element() hostElement: HTMLElement;

  /** Use the gray variant instead of blue. */
  @Prop() gray: boolean = false;
  /** Add border to table. */
  @Prop() bordered: boolean = false;
  /** Make the table striped. */
  @Prop() striped: boolean = false;

  getClassNames(): string {
    const classes = [this.striped && 'striped', this.bordered && 'bordered', this.gray ? 'color-gray' : 'color-blue'];

    return classes.filter(Boolean).join(' ');
  }

  render() {
    return (
      <Host class={this.getClassNames()}>
        <div class="pn-table-container">
          <slot />
        </div>
      </Host>
    );
  }
}
